import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import { transformPieChartStationDetail } from '../ProductionDashboardHelpers';

export default function PeopleTab({ qualityChecks, safetyChecks, productionErrors }) {
  return (
    <div>
      <h3>People Performance</h3>
      <div className="charts-grid">
        {qualityChecks.length > 0 && (
          <MarketShare
            data={transformPieChartStationDetail(qualityChecks)}
            radius={['95%', '83%']}
            title="Quality Checks By Staff"
          />
        )}
        
        {safetyChecks.length > 0 && (
          <MarketShare
            data={transformPieChartStationDetail(safetyChecks)}
            radius={['95%', '83%']}
            title="Safety Checks By Staff"
          />
        )}

        {productionErrors.length > 0 && (
          <MarketShare
            data={transformPieChartStationDetail(productionErrors)}
            radius={['95%', '83%']}
            title="Production Errors By Staff"
          />
        )}

        {qualityChecks.length === 0 && safetyChecks.length === 0 && productionErrors.length === 0 && (
          <div className="w-100 p-4 text-center border rounded">No people performance data available for this date.</div>
        )}
      </div>
    </div>
  );
}

PeopleTab.propTypes = {
  qualityChecks: PropTypes.array.isRequired,
  safetyChecks: PropTypes.array.isRequired,
  productionErrors: PropTypes.array.isRequired
};
